import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthorizationActions, ModalOverlayRef, ModulesSelectors } from '@serviceos-ng/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
    selector: 'serviceos-web-preference-alert',
    templateUrl: './preference-alert.component.html',
    styleUrls: ['./preference-alert.component.scss'],
})
export class PreferenceAlertComponent implements OnInit {
    public componentConfig$!: Observable<any>;

    constructor(
        private modalRef: ModalOverlayRef,
        private router: Router,
        private store: Store,
        private cookieService: CookieService
    ) {
        
    }

    ngOnInit(): void {
        this.componentConfig$ = this.store
            .select(
                ModulesSelectors.getComponentFromModule(
                    'account',
                    'preference_alert_modal'
                )
            )
            .pipe(
                map((res) => {
                    if (res) {
                        return res;
                    } else {
                        return {
                            title:
                                'Receive exclusive promotions, promo cores, service updates and tips!',
                            content:
                                'choose how you\'d like to hear about them in your Account Settings',
                            close_btn: 'No, Thanks',
                            continue_btn: 'Receive Promotions',
                        };
                    }
                })
            );
    }

    closeModal() {
        this.modalRef.close();
    }

    goToRenewMemberShip() {
        this.router.navigate(['account-settings']);
        this.modalRef.close();
    }
}
